import { generateConst } from '@/utils/constants'

const checkTypeRegistry = {
  COMPANY: { value: 1, label: '会社' },
  REPRESENTATIVE: { value: 2, label: '代表者' },
  INDIVIDUAL: { value: 3, label: '個人' }
}

export const UserComplianceCheckType = generateConst(checkTypeRegistry)
